import SwatchHelper from "./SwatchHelper";

export const swatchUrlChanger = (productBlocksSelector) => {
    let eventInit = false;
    let swatchHelper = new SwatchHelper(productBlocksSelector);
    swatchHelper.onSwatchRendered((node, searchedNode) => {
        if (!eventInit) {
            document.addEventListener("vsk:product:changed", (event) => {
                let productCard = event.target.closest("[swatch-generated]");
                let productHandle = productCard.getAttribute("swatch-generated");
                productCard.querySelectorAll("a").forEach((element) => {
                    let href = element.getAttribute("href");
                    let newHref = href.replace(/(.*\/).*$/g, "$1" + productHandle);
                    element.setAttribute("href", newHref);
                });
            });
        }
        eventInit = true;
    });
};
